<template>
  <div>
    <div class="con-vs-alert con-vs-alert-danger mb-4">
      <div class="vs-alert text-center">Essa função está disponível apenas para clientes Vip
        <a :href="`${linkVip}`" rel="noopener">Ver Plano Vip</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      linkVip: process.env.VUE_LINK_VIP,
      dispositivo: {}
    };
  },
  mounted() {
    this.dispositivo = JSON.parse(this.$localStorage.get('mobile'));
  }
};
</script>
